import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Switch } from "scmp-sdk/components";
import "swiper/css";
import { SwiperSlide } from "swiper/react";

import {
  fontRobotoCondensed,
  setFullViewportWidthStyles,
  theme,
  transientOptions,
} from "shared/lib/styles";

import ArrowNext from "./arrow-next.svg";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;

  padding-block: 12px;

  border-radius: 12px;

  background: #e5e5e5;

  ${theme.breakpoints.up("tablet")} {
    gap: 20px;

    padding-block: 20px;
  }

  ${theme.breakpoints.only("mobile")} {
    ${setFullViewportWidthStyles()}
    border-radius: 0;
  }
`;

export const Header = styled.div`
  display: flex;
  gap: 40px;
  justify-content: space-between;
  align-items: center;

  padding-inline: 20px;

  ${theme.breakpoints.up("desktop")} {
    justify-content: flex-start;
  }
`;

export const Title = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
  text-transform: uppercase;

  ${theme.breakpoints.up("tablet")} {
    font-size: 16px;
  }
`;

export const ToggleContainer = styled.label`
  display: inline-flex;
  gap: 8px;
  align-items: center;

  color: #666666;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  white-space: nowrap;
`;

export const ToggleLabel = styled.span`
  font-size: 14px;
  line-height: 100%;
`;

type StyledSwitchProps = {
  $enabled: boolean;
};

export const StyledSwitch = styled(Switch, { ...transientOptions })<StyledSwitchProps>`
  && .base-Switch-track {
    background-color: ${props => (props.$enabled ? "#2c4692" : "#cccccc")};
  }
`;

export const StyledSwiperSlide = styled(SwiperSlide)`
  inline-size: auto;
`;

export const SwiperWrapper = styled.div`
  position: relative;

  overflow: visible;

  &:hover {
    .card-swiper-button-prev,
    .card-swiper-button-next {
      opacity: 1;
    }
  }

  .card-swiper-button-prev,
  .card-swiper-button-next {
    position: absolute;
    inset-block-start: 50%;
    z-index: 10;

    display: none;

    inline-size: 32px;
    block-size: 32px;

    border-radius: 999px;

    background: rgba(0, 0, 0, 0.35);

    cursor: pointer;

    opacity: 0;
    transform: translateY(-50%);

    pointer-events: auto;

    transition: opacity 250ms ease;

    ${theme.breakpoints.up("tablet")} {
      display: block;
    }
  }

  .card-swiper-button-prev {
    inset-inline-start: -8px;
  }

  .card-swiper-button-next {
    inset-inline-end: -8px;
  }

  .card-swiper-button-disabled {
    opacity: 0;

    pointer-events: none;
  }
`;

const ArrowStyle = css`
  inset-block-start: 50%;

  display: none;

  block-size: 48px;

  ${theme.breakpoints.up("tablet")} {
    position: absolute;
    z-index: 10;

    display: block;

    cursor: pointer;

    pointer-events: auto;
  }
`;

export const StyledArrowNext = styled(ArrowNext)`
  transform: translateY(-50%);

  ${ArrowStyle}

  ${theme.breakpoints.up("tablet")} {
    inset-inline-end: -8px;
  }
  ${theme.breakpoints.up("desktop")} {
    flex-direction: row;
    align-items: flex-start;
  }
`;

export const StyledArrowPrevious = styled(ArrowNext)`
  transform: translateY(-50%) rotate(180deg);

  ${ArrowStyle}

  ${theme.breakpoints.up("tablet")} {
    inset-inline-start: -8px;
  }
  ${theme.breakpoints.up("desktop")} {
    flex-direction: row-reverse;
    align-items: flex-start;
  }
`;
